import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const api = axios.create({ baseURL: API });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  const branchId = localStorage.getItem("currentBranchId");
  if (branchId) config.headers["X-Branch-Id"] = branchId;
  return config;
});

api.interceptors.response.use(
  (r) => r,
  (err) => {
    if (err?.response?.status === 401 && !window.location.pathname.startsWith("/login") && !window.location.pathname.startsWith("/book")) {
      localStorage.removeItem("token");
      localStorage.removeItem("user");
      window.location.href = "/login";
    }
    return Promise.reject(err);
  }
);

export default api;

export const fileUrl = (path) => {
  if (!path) return null;
  const token = localStorage.getItem("token");
  return `${API}/files/${path}?auth=${token}`;
};

export const publicFileUrl = (path) => path ? `${API}/files-public/${path}` : null;
